import React from 'react';
import ReactDOM from 'react-dom/client';
import Routes from './routes';
import './index.less';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router, } from 'react-router-dom'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
        <Routes />
  </Router>
);
reportWebVitals();
    